export default __webpack_public_path__ + "static/media/postgresql-logo.52d31cc1.png";